import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://cgiqxdzswzpwczdhuwwu.supabase.co';
const supabaseAnonKey = 'sb_publishable_OgtiBPmZl7tikQnW0490bQ_3o75y7-g';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'smp-auth-token',
  }
});
